






























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import EmployeeInfo from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/EmployeeInfo";
import TeacherCategory from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/TeacherCategory";
@Component
export default class EmployeeDetailComponent extends Vue {
  @Prop()
  employee: EmployeeInfo;
  getCategoryName(category: TeacherCategory):String
  {
    var str = category.Name;
    switch(category.Type){
      case 0:
        str += ' квалификационная категория учителя';
        break;
      case 1:
        str += ' квалификационная категория завуча';
        break;
      case 2:
        str += ' квалификационная категория директора';
        break;
      case 3:
        str += ' квалификационная категория воспитателя';
        break;
    }
    return str;
  }
  
}
